import { render, staticRenderFns } from "./EmployeeWidget.vue?vue&type=template&id=6eb6c64b&"
import script from "./EmployeeWidget.vue?vue&type=script&lang=ts&"
export * from "./EmployeeWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports